import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, NakedButton, Text } from '@frontend/design-system';
import { UserCreationTrackingIds } from './tracking-ids';

interface BeginUserSetupProps {
  onBeginSetupClick: () => void;
}

export const BeginUserSetup: FC<BeginUserSetupProps> = ({ onBeginSetupClick }) => {
  const { t } = useTranslation('userCreate', { keyPrefix: 'begin-setup' });

  return (
    <div css={containerStyles}>
      <Heading level={1}>{t('Welcome to Weave')}</Heading>
      <Heading level={3}>{t("Let's set up your account")}</Heading>
      <NakedButton
        css={continueButtonStyles}
        onClick={onBeginSetupClick}
        trackingId={UserCreationTrackingIds.beginSetup}
      >
        <Text weight='bold' size='medium' color='white'>
          {t('Continue to Setup')}
        </Text>
      </NakedButton>
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'center',
});

const continueButtonStyles = css({
  backgroundColor: theme.colors.neutral90,
  padding: theme.spacing(0, 2),
  height: theme.spacing(4),
  borderRadius: theme.borderRadius.small,
  marginTop: theme.spacing(1),
});
